import { SwiperOptions } from 'swiper/types/swiper-options';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { FunctionsService } from '@app/modules/core/services/functions.service';
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { QrGeneratorNavigatorRESTAURANTMENU, QrGeneratorNavigatorRestaurantMenuDataSectionItem, QrGeneratorNavigatorRestaurantMenuDataSectionItemSubOption } from 'shared-library';

declare const bootstrap: any

@Component({
  selector: 'app-qrs-restaurant-menu',
  templateUrl: './qrs-restaurant-menu.component.html',
  styleUrls: ['./qrs-restaurant-menu.component.scss', '../qrs-wrapper.component.scss']
})
export class QrsRestaurantMenuComponent implements OnInit {

  @Input() qr_url: string;
  @Input() social_data: SocialHelper;
  @Input() data: QrGeneratorNavigatorRESTAURANTMENU;
  product: QrGeneratorNavigatorRestaurantMenuDataSectionItem
  potential_cart_entry: { item_id: number; thumbnail: string; title: string; quantity: number; unit_price: number; descriptions: string[]; subs: Record<string, number[]> }
  cart: Array<typeof this.potential_cart_entry> = [];
  active_view: 'products' | 'product' | 'summary' = 'products';

  private offcanvas_element: any;
  private active_class_name = 'active';
  @ViewChild('previewWrapper') previewWrapper: ElementRef;
  @ViewChild('scrollspyContainer') scrollspyContainer: ElementRef;

  constructor(
    private renderer: Renderer2,
    public readonly functionService: FunctionsService
  ) { }

  ngOnInit(): void {
    this.functionService.initializeTooltip()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initCustomScrollSpy()
    }, 1000)
  }

  private initCustomScrollSpy(): void {
    this.handleScrollCheck()
    window.addEventListener('scroll', this.handleScrollCheck.bind(this), true);
  }

  private handleScrollCheck() {
    if (!this.scrollspyContainer?.nativeElement || !this.previewWrapper?.nativeElement) {
      this.functionService.logToConsole("Not initialised")
      return
    }
    const container = this.scrollspyContainer.nativeElement as HTMLElement;
    const sections = container.querySelectorAll('[data-spy="scroll"]');

    const getVisiblePercentage = (element: HTMLElement): number => {
      const element_rect = element.getBoundingClientRect();
      const view_port_height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      if (element_rect.top >= view_port_height || element_rect.bottom < 0) {
        // Not visible yet
        return 0;
      }
      if (element_rect.top >= 0 && element_rect.height <= view_port_height) {
        // The whole of element is visible
        return 100
      }
      return this.functionService.percentageCalculatorV2(element_rect.bottom, view_port_height)
    }

    let full_found = false
    sections.forEach((section: HTMLElement) => {
      if (full_found) return;
      const targetId = section.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;
      const percentage_showing = getVisiblePercentage(section)
      if (percentage_showing >= 50) {
        // Reset all
        this.resetActiveClass()
        this.renderer.addClass(targetElement, this.active_class_name);
        targetElement.style.color = this.data.colors.text_color
        targetElement.style.backgroundColor = this.data.colors.primary_color
        full_found = percentage_showing === 100
      }
    });
  }

  private resetActiveClass() {
    this.previewWrapper.nativeElement.querySelectorAll(`.nav-link.${this.active_class_name}`).forEach((link: HTMLElement) => {
      link.classList.remove(this.active_class_name);
      link.style.color = "#2A2A2A"
      link.style.backgroundColor = "#f5f5f5"
    })
  }

  viewItem(item: QrGeneratorNavigatorRestaurantMenuDataSectionItem) {
    this.product = item;
    this.potential_cart_entry = {
      quantity: 1,
      descriptions: [],
      item_id: item.id,
      unit_price: item.price,
      title: item.headings.main,
      thumbnail: item.thumbnail,
      subs: {}
    }
    for (const sub of item.subs) {
      this.potential_cart_entry.subs[`${sub.id}`] = [];
      if (sub.is_required && sub.show && !sub.is_multi_select && sub.options.length) {
        this.potential_cart_entry.subs[`${sub.id}`].push(sub.options[0].id)
        this.potential_cart_entry.descriptions = [sub.options[0].title]
      }
    }
    this.changeView('product')
  }

  calculateCartItems(): number {
    let _i = 0;
    for (const c of this.cart) _i += c.quantity
    return _i
  }

  addToCart() {

    const isEqual = (cart: typeof this.potential_cart_entry) => {

      const cart_cloned: typeof this.potential_cart_entry = JSON.parse(JSON.stringify(cart));
      const potential_cart_cloned = JSON.parse(JSON.stringify(this.potential_cart_entry));
      for (const key in cart_cloned.subs) {
        if (Object.prototype.hasOwnProperty.call(cart_cloned.subs, key)) {
          cart_cloned.subs[key].sort()
        }
      }
      for (const key in potential_cart_cloned.subs) {
        if (Object.prototype.hasOwnProperty.call(potential_cart_cloned.subs, key)) {
          potential_cart_cloned.subs[key].sort()
        }
      }
      return cart.item_id === this.potential_cart_entry.item_id && JSON.stringify(cart.subs) === JSON.stringify(this.potential_cart_entry.subs)
    }

    let found = false;
    for (const cart of this.cart) {
      if (isEqual(cart)) {
        cart.quantity += this.potential_cart_entry.quantity
        found = true
        break
      }
    }
    if (!found) {
      // Validate at least one required option is selected
      for (const required_subs of this.product.subs.filter(sub => sub.show && sub.is_required && sub.is_multi_select && sub.options.length)) {
        if (!this.potential_cart_entry.subs[required_subs.id.toString()].length) {
          this.functionService.showErrorMessage(`${required_subs.title} is required to add to cart.`)
          return
        }
      }
      this.cart.push(JSON.parse(JSON.stringify(this.potential_cart_entry)))
    }
    this.changeView('products');
  }

  openCanvas(id: 'menuItemDetails') {
    this.offcanvas_element = new bootstrap.Offcanvas(document.getElementById(id), {
      keyboard: false
    })
    this.offcanvas_element.show()
  }

  changeView(view: typeof this.active_view) {
    this.active_view = view;
    this.functionService.initializeTooltip()
    this.functionService.updateCheckboxColor(document.getElementById('menuItemDetails'), this.data.colors.secondary_color)
    if (view === 'products') {
      this.offcanvas_element?.hide()
      return
    }
    this.openCanvas('menuItemDetails')
  }

  reCalculatePrice() {
    if (!this.product) return
    let total = 0
    for (const sub of this.product.subs) {
      for (const option of sub.options) {
        if (sub.options.length && this.potential_cart_entry.subs[sub.id.toString()].includes(option.id)) {
          total += option.price
        }
      }
    }
    this.potential_cart_entry.unit_price = (total || this.product.price)
  }

  pushPopOption({ id: optionId, title }: QrGeneratorNavigatorRestaurantMenuDataSectionItemSubOption, options: number[]) {
    const index = options.findIndex(option => option === optionId);
    if (index === -1) {
      options.push(optionId);
      this.potential_cart_entry.descriptions.push(title);
      return
    }
    options.splice(index, 1);
    this.potential_cart_entry.descriptions.splice(this.potential_cart_entry.descriptions.findIndex(d => d === title), 1);
  }

  gotoProduct(productId: number) {
    for (const section of this.data.menu.sections) {
      for (const item of section.items) {
        if (item.id === productId) {
          this.viewItem(item)
          break
        }
      }
    }
  }

  cartTotal(): number {
    let total = 0
    for (const cart_item of this.cart) {
      total += (cart_item.unit_price * cart_item.quantity)
    }
    return total
  }

  scrollToElement(id: string, event: Event) {
    const targetElement = this.previewWrapper.nativeElement.querySelector('[data-target="' + id + '"]');
    if (!targetElement || !event.target) return
    this.functionService.scrollToElement(targetElement)
  }

}
